function CoreWeb() {
}

CoreWeb.fn = {
    init: function () {
        CoreWeb.fn.changeTypePassword.call(this);
        CoreWeb.fn.toggleClass.call(this);
        CoreWeb.fn.userAsideTrigger.call(this);
        CoreWeb.fn.toggleShowHideContent.call(this);
    },

    // Below this width the header account icon opens the profile sidebar
    // instead of navigating through its own href.
    mobileBreakpoint: 992,

    changeTypePassword: function () {
        var showClass = "is-shown";
        var hideClass = "is-hidden";

        // Delegated so the toggle also works inside markup injected later
        // (login/register popups), not just the fields present at DOM ready.
        $(document).on("click", ".passcode-switch", function (e) {
            e.preventDefault();

            var $switch = $(this);
            var targetId = $switch.data("target");
            var $input = targetId ? $("#" + targetId) : $();

            // data-target is the contract, but fall back to the field wrapped
            // alongside the switch when the id is missing or duplicated.
            if (!$input.length) {
                $input = $switch.closest(".form-control-wrap").find('input[type="password"], input[type="text"]').first();
            }

            if (!$input.length) {
                return;
            }

            // Read the live input type instead of the CSS state class so the
            // two can never drift apart.
            if ($input.attr("type") === "text") {
                $input.attr("type", "password");
                $switch.add($input).addClass(hideClass).removeClass(showClass);
            } else {
                $input.attr("type", "text");
                $switch.add($input).addClass(showClass).removeClass(hideClass);
            }
        });
    },

    // Returns false when the page has no matching [data-content] to slide out.
    toggleContent: function (target) {
        var $content = $('[data-content="' + target + '"]');

        if (!$content.length) {
            return false;
        }

        $content.toggleClass('content-active');

        if ($content.hasClass('content-active')) {
            if (!$content.next('.toggle-overlay').length) {
                $content.after('<div class="toggle-overlay" data-target="' + target + '"></div>');
            }
            $('body').addClass('toggle-shown');
        } else {
            $content.next('.toggle-overlay').remove();
            $('body').removeClass('toggle-shown');
        }

        return true;
    },

    toggleClass: function () {
        $(document).on('click', '.toggle', function (e) {
            e.preventDefault();

            CoreWeb.fn.toggleContent($(this).data('target'));
        });

        $(document).on('click', '.toggle-overlay', function (e) {
            e.preventDefault();

            var target = $(this).data('target');
            $('[data-content="' + target + '"]').removeClass('content-active');
            $(this).remove();
            $('body').removeClass('toggle-shown');
        });
    },

    userAsideTrigger: function () {
        $(document).on('click', '#user-control-nav', function (e) {
            if (window.innerWidth >= CoreWeb.fn.mobileBreakpoint) {
                return;
            }

            // Pages without the sidebar keep the link's normal navigation.
            if (CoreWeb.fn.toggleContent('userAside')) {
                e.preventDefault();
            }
        });
    },

    toggleShowHideContent: function () {
        $(document).on('click', '.btn-more', function (e) {
            $("#toggle-content").toggleClass('toggle-show-hide');

            if ($(this).closest('#toggle-content').hasClass('toggle-show-hide')) {
                $(this).text('Xem thêm nội dung');
            } else {
                $(this).text('Thu gọn nội dung');
            }
        });
    },

    rule: function () {
        $(document).ready(function () {
            CoreWeb.fn.init.call(this);
        });
    },
};

CoreWeb.fn.rule();
